import { TenantConfig } from '@/core';

export const hostnameSlug = (hostname: string): string => {
  if (hostname.includes('localhost')) {
    return 'dev';
  }

  if (hostname.includes('doctool-dev')) {
    return hostname.startsWith('eng-doctool') ? 'dev-eng' : 'dev';
  }

  const splittedTenant = hostname.split('.');
  const extractedSlug = splittedTenant[0];
  const hasSubdomain = splittedTenant.length > 3;

  if (/(feature|bugfix)-EP-[0-9]+/i.test(extractedSlug) || /(release)(-[0-9]+){3}/i.test(extractedSlug)) {
    return extractedSlug.startsWith('eng-doctool') ? 'dev-eng' : 'dev';
  }

  if (hasSubdomain) {
    return `${extractedSlug}-${splittedTenant[1]}`;
  }

  if (new RegExp(/[0-9]/, 'g').test(extractedSlug)) {
    if (extractedSlug.indexOf('-') !== -1) {
      return extractedSlug;
    }

    const string = extractedSlug.split(/\d/);

    return extractedSlug.replace(string[0], '$&-');
  }

  return extractedSlug;
};

const loadTenantConfig = (slug): Promise<TenantConfig> =>
  import(`./tenants/${slug}.ts`).then((config) => config.default());

const currentTenant = () => {
  const slug = hostnameSlug(window.location.hostname);
  return loadTenantConfig(slug).catch(() => {
    console.warn(`Couldn't find tenant ${slug}. Loading 'default' tenant`);
    return loadTenantConfig('default');
  });
};

export default async () => await currentTenant();
